import { render, staticRenderFns } from "./DamSupport.vue?vue&type=template&id=8c0ad254&scoped=true"
import script from "./DamSupport.vue?vue&type=script&lang=ts"
export * from "./DamSupport.vue?vue&type=script&lang=ts"
import style0 from "./DamSupport.vue?vue&type=style&index=0&id=8c0ad254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0ad254",
  null
  
)

export default component.exports